<template>
    <!-- New design -->

     <a-row type="flex" align="middle" class="networking-row">
      <a-col :flex="isMobile ? '56px' : '80px'">
        <div class="avatar-wrap">
          <router-link :to="userProfileLink">
						<img
						class="frame"
						:src="
							imageBaseUrl +
							'api/users/' +
							'pictureframe?rol_id=' +
							user.rol_id +
							'&type=circle' +
							'&sid=' +
							sid
						"
						alt=""
						/>
						<a-avatar :size="isMobile ? 48 : 72" icon="user" shape="circle" :src="image" alt="userProfile.png" class="networking-avatar" />
          </router-link>
					</div>
      </a-col>
      <a-col :flex="!isMobile ? 'auto' : '18'">
        <router-link :to="userProfileLink"><p class="networking-name">{{ user.usr_firstname + " " + user.usr_lastname }}</p></router-link>
        <!-- City, Country -->
        <!-- <p class="networking-location" v-if="user.usr_city || user.cnt_id">{{ user.usr_city }}{{ user.usr_city && user.cnt_id ? ',' : '' }} {{ user.cnt_id }}</p> -->
        <!-- <p class="networking-location" v-else>No location</p -->
        <!-- Title at company -->
        <p class="networking-location">{{ usr_other.company_title ? usr_other.company_title : ' ' }}</p>
        <p class="networking-company">{{ usr_other.company_name ? usr_other.company_name : ' ' }}</p>
      </a-col>
      <a-col v-if="!isMobile" key="desktopChat" style="margin-right:10px">
        <a-button type="default" icon="message" @click.native="openChat(user.usr_id)" class="networking-button">{{$t('networking.startChat')}}</a-button>
      </a-col>
      <a-col :span="3" v-else key="mobileChat">
        <a-button type="default" icon="message" @click.native="openChat(user.usr_id)" class="networking-button"></a-button>
      </a-col>
      <a-col v-if="!isMobile" key="desktopProfile">
        <router-link :to="userProfileLink">
            <a-button type="default" icon="user" class="networking-button">{{ isMobile ? '' : $t('networking.viewProfile')}}</a-button>
        </router-link>
      </a-col>
      <a-col :span="3" v-else key="mobileProfile">
        <router-link :to="userProfileLink">
            <a-button type="default" icon="user" class="networking-button">{{ isMobile ? '' : $t('networking.viewProfile')}}</a-button>
        </router-link>
      </a-col>
    </a-row>

<!-- Old design -->

<!--   <div class="each-user-wrapper" :class="{ selected: showingAdditionalInfo }">
 -->    <!-- <div class="attendee-block" @click="showingAdditionalInfo =! showingAdditionalInfo"> -->
    <!-- <div class="attendee-block">
      <transition name="slide-in">
        <div class="heading" v-if="showingAdditionalInfo">
          <div>{{ $t("listOfAttendees.attendee") }}</div>
        </div>
      </transition>
      <div class="content">
        <div class="avatar-wrapper">
          <div class="img-wrapper">
            <img
              class="frame"
              :src="
                imageBaseUrl +
                'api/users/' +
                'pictureframe?rol_id=' +
                rol_id +
                '&type=square' +
                '&sid=' +
                sid
              "
              draggable="false"
            />
            <router-link :to="userProfileLink" href=""
              ><img :src="image" alt="userProfile.png"
            /></router-link>
            <div class="green-dot" v-if="user.usr_active"></div>
          </div>
        </div>
        <div class="info-wrapper">
          <p>{{ user.usr_firstname + " " + user.usr_lastname }}</p>
          <div>
            <span class="icon">
              <img :src="$images.location" alt="location.png" />
            </span>
            <span
              v-tooltip="{
                content:
                  user.usr_firstname.length > 27 ? user.usr_firstname : null,
              }"
              class="text"
              :class="{ grayed: !user.usr_firstname }"
            >
              {{
                user.usr_city
                  ? checkLineLength(user.usr_city)
                  : $t("listOfAttendees.defaultLocation")
              }}
            </span>
          </div>
          <div>
            <span class="icon">
              <img :src="$images.job" alt="job.png" />
            </span>
            <span
              v-tooltip="{
                content:
                  usr_other.company_name ? usr_other.company_name : null,
              }"
              class="text"
              :class="{ grayed: !usr_other.company_name }"
            >
              {{
                usr_other.company_name
                  ? checkLineLength(usr_other.company_name)
                  : $t("listOfAttendees.defaultPosition")
              }}
            </span>
          </div>
          <div>
            <span class="icon">
              <img :src="$images.uni" alt="university.png" />
            </span>
            <span
              v-tooltip="{ content: usr_other.uni_name }"
              class="text"
              :class="{ grayed: !usr_other.uni_name }"
            >
              {{
                usr_other.uni_name
                  ? checkLineLength(usr_other.uni_name)
                  : $t("listOfAttendees.defaultUni")
              }}
            </span>
          </div>
        </div>
      </div>
    </div> -->
<!--     <transition name="slide-in">
 -->      <!-- <div class="looking-for-block" v-if="showingAdditionalInfo" @click="showingAdditionalInfo =! showingAdditionalInfo"> -->
      <!-- <div class="looking-for-block" v-if="showingAdditionalInfo">
        <div class="heading">
          <div>{{ $t("listOfAttendees.lookingFor") }}</div>
        </div>
        <div class="content">
          <div
            class="border-wrapper"
            :class="{ selected: showingAdditionalInfo }"
          >
            <p>Computed science</p>
            <p>Virtual events</p>
            <p>Communities</p>
            <router-link :to="userProfileLink" href=""
              >See {{ user.usr_firstname }}'s profile.</router-link
            >
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-in"> -->
      <!-- <div class="avail-block" v-if="showingAdditionalInfo" @click="showingAdditionalInfo =! showingAdditionalInfo"> -->
      <!-- <div class="avail-block" v-if="showingAdditionalInfo">
        <div class="heading">
          <div>{{ $t("listOfAttendees.availability") }}</div>
        </div>
        <div class="content">
          <div
            class="border-wrapper"
            :class="{ selected: showingAdditionalInfo }"
          >
            <p>
              {{ user.usr_firstname }} is currently available for a meeting<span
                class="green-rectangle"
              ></span>
            </p>
            <p>
              <b>Number of mutual empty meeting slots:</b
              ><span class="red-number"> 3</span>
            </p>
            <p class="last">
              <b>See {{ user.usr_firstname }}'s</b>
              <router-link :to="'#'">meeting calendar</router-link>.
            </p>
          </div>
        </div>
      </div>
    </transition>
    <div class="action-block">
      <transition name="slide-in">
        <div class="heading" v-if="showingAdditionalInfo">
          <div>{{ $t("listOfAttendees.action") }}</div>
        </div>
      </transition>
      <div class="content">
        <div
          class="border-wrapper"
          :class="{ selected: showingAdditionalInfo }"
        >
          <div class="button-line">
            <basic-button @click.native="openChat(user.usr_id)">
              <span>{{ $t("listOfAttendees.sendMessage") }}</span>
              <span><img :src="$images.sendIcon" alt="send.png" /></span>
            </basic-button> -->
            <!-- <basic-button
              :color="
                isCalendlyLinkPresent(user.usr_socnet)
                  ? '#e2bbbb'
                  : cssVar('button-color-washed-red')
              "
              :disabled="isCalendlyLinkPresent(user.usr_socnet)"
              @click.native="bookMeeting(user.usr_socnet)"
            >
              <span>{{ $t("listOfAttendees.bookMeeting") }}</span>
              <span><img :src="$images.meeting" alt="meeting.png" /></span>
            </basic-button> -->
<!--           </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { cssVar } from "../../js/colorHelpers";
/* import BasicButton from "./BasicButton";*/
import isMobileMixin from "../../mixins/isMobileMixin";
export default {
  /* components: {
    BasicButton,
  }, */
  props: {
    user: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      image: "",
      showingAdditionalInfo: false,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  mixins: [isMobileMixin],
  computed: {
    usr_other () {
      if(this.user.usr_other) {
        return JSON.parse(this.user.usr_other)
      }
      return {}
    },
    sid() {
      return localStorage.getItem('sid')
    },
    userProfileLink() {
      return (
        "/profile/" +
        this.user.usr_firstname +
        "-" +
        this.user.usr_lastname +
        "-" +
        this.user.usr_id
      );
    },
  },
  watch: {
    user: {
      handler() {
        this.getUserAvatar();
        this.showingAdditionalInfo = false;
      },
    },
  },
  created() {
    this.getUserAvatar();
  },
  methods: {
    cssVar,
    async getUserAvatar() {
      try {
        this.startLoading();
        this.image = await this.getImageUsrId(this.user.usr_id);
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    openChat(userId) {
      let obj = {
        location: "dm",
        userId,
      };
      this.EventBus.$emit("chatProp", obj);
    },
    bookMeeting(unparsedInfo) {
      const data = JSON.parse(unparsedInfo);
      window.location.href = data.calendly;
    },
    isCalendlyLinkPresent(unparsedInfo) {
      if (!unparsedInfo) {
        return true;
      }
      const data = JSON.parse(unparsedInfo);
      if (data.calendly === undefined) {
        return true;
      } else {
        return false;
      }
    },
    checkLineLength(string) {
      if (string.length > 27) {
        return string.slice(0, 27) + "...";
      } else {
        return string;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-wrap {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  .frame {
    position: absolute;
	z-index: 9;
  }
}

* {
  box-sizing: border-box;
}
a {
  color: #6d8ad9;
}
.each-user-wrapper {
  display: flex;
  min-height: 140px;
  flex-wrap: wrap;
  margin: 10px 0;

  .heading {
    display: flex;
    align-items: center;
    height: 30px;

    div {
      display: flex;
      align-items: center;
      max-height: 0;
      padding-left: 10px;
      border-left: 1px solid #c1c1c1;
      font-weight: 900;
      font-size: 20px;
      height: 100%;
    }
  }

  .content {
    display: flex;
    overflow-wrap: break-word;
    background: #f9f9f9;
    // background-color: #6D8AD9;
    padding: 10px 0;
    height: calc(100% - 30px);
  }

  .border-wrapper {
    padding-left: 10px;
    flex-basis: 100%;
    &.selected {
      border-left: 1px solid #c1c1c1;
    }
  }

  .attendee-block {
    flex-basis: 27%;
    // cursor: pointer;
    .content {
      padding: 10px;
      border-radius: 10px 0 0 10px;
      .avatar-wrapper {
        flex-basis: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        .img-wrapper {
          position: relative;
          width: 45px;
          height: 45px;
          .frame {
            position: absolute;
            width: 100%;
          }
          .green-dot {
            position: absolute;
            width: 12px;
            height: 12px;
            right: -3px;
            bottom: -3px;
            border-radius: 50%;
            background-color: #69d200;
            z-index: 99999;
          }
          img {
            cursor: pointer;
            border-radius: 10px;
          }
        }
      }
      .info-wrapper {
        flex-basis: calc(100% - 45px);
        padding: 0 0 0 15px;
        p {
          margin: 0;
          margin-bottom: 7px;
          font-size: 18px;
          font-weight: 500;
        }
        > div {
          display: flex;
          align-items: center;
          margin: 3px 0;
          .text {
            font-size: 13px;
            &.grayed {
              color: #c4c4c4;
            }
          }
          .icon {
            display: flex;
            align-items: center;
            margin-right: 11px;
            img {
              min-width: 17px;
              min-height: 17px;
            }
          }
        }
      }
    }
    .heading div {
      border: none;
    }
  }
  .looking-for-block {
    flex-basis: 18%;
    cursor: pointer;
    .content {
      .border-wrapper {
        flex-direction: column;
        p {
          margin: 1px 0;
        }
        a {
          display: inline-block;
          margin-top: 10px;
        }
      }
    }
  }
  .avail-block {
    flex-basis: 25%;
    cursor: pointer;
    .content {
      .border-wrapper {
        flex-direction: column;
        p {
          margin: 1px 0;
          &.last {
            margin-top: 30px;
          }
        }
      }
    }
  }
  .action-block {
    flex-basis: 30%;
    .content {
      border-radius: 0 10px 10px 0;
      .border-wrapper {
        display: flex;
        align-items: center;
        .button-line {
          display: flex;
          flex-direction: row;
          flex-basis: 100%;
          justify-content: space-evenly;
        }
      }
    }
  }
}

.green-rectangle {
  display: inline-block;
  width: 31px;
  height: 12px;
  background: #1cc60d;
}
.red-number {
  color: #f01b1b;
  font-weight: 500;
}

//Media Queries
@media (max-width: 1366px) {
  .each-user-wrapper {
    // background-color: lightgray;
    border-radius: 10px;
    overflow: hidden;
    .attendee-block,
    .looking-for-block,
    .avail-block,
    .action-block {
      flex-basis: 50%;
    }
  }
}

@media (max-width: 962px) {
  .each-user-wrapper {
    height: auto;
    .attendee-block,
    .looking-for-block,
    .avail-block,
    .action-block {
      flex-basis: 100%;
      min-height: 100px;
    }
    .content {
      height: auto;
    }
  }
  .each-user-wrapper {
    .attendee-block {
      .content {
        .info-wrapper {
          display: flex;
          align-items: center;
        }
        .info-wrapper > div {
          margin: 0 10px;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .each-user-wrapper {
    border-radius: 10px;
    overflow: hidden;
    .attendee-block,
    .looking-for-block,
    .avail-block,
    .action-block {
      flex-basis: 100%;
    }
    .border-wrapper {
      padding: 0 0 0 5px;
    }
    .action-block {
      .content {
        min-height: 100px;
        .border-wrapper {
          .button-line {
            display: flex;
            flex-wrap: wrap;
          }
        }
      }
    }
    .attendee-block {
      min-height: 120px;
      .content {
        padding: 5px;
        .info-wrapper {
          flex-direction: column;
          align-items: flex-start;
          padding-left: 10px;
          p {
            font-size: 16px;
          }
          div {
            margin: 1px 0;
            .icon {
              max-width: 10px;
              max-height: 10px;
            }
            .text {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}

// Transition
.slide-in-enter,
.slide-in-leave-to {
  visibility: hidden;
  max-height: 1000px;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.2s ease-out;
}
</style>